(function () {
    'use strict';

    var component = {
        transclude: true,
        templateUrl: 'app/js/components/payment-providers-settings/settings-provider-chargebackfees-component/settings-provider-chargebackfees.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmSPC",
        bindings: {
            provider: '<',
            paymentProviderExternalId: '<',
            redirectUrl: '@'
        }
    };

    iteroComponents.component('settingsProviderChargebackfees', component);

    controller.$inject = ['PaymentProviderHandlingFeesSettings', '$location'];

    function controller(paymentProviderHandlingFeesSettings, $location) {
        var vm = this;

        vm.HANDLING_FEES_MODE = Object.freeze({
            'Automatically': 0,
            'Custom': 1
        });

        const CUSTOM_HANDLING_FEE_TYPE = Object.freeze({
            'None': 0,
            'CreditCard': 1,
            'DirectDebit': 2,
            'PayPal': 3
        });

        const PSP_TYPE = Object.freeze({
            'PayPal': 'PayPal',
            'GoCardless': 'GoCardless',
            'FakeProvider': 'FakeProvider',
            'PayOne': 'PayOne',            
            'Stripe': 'Stripe',
            'StripeV2': 'StripeV2',
            'Unzer': 'Unzer',
            'UnzerV2': 'UnzerV2',
            'Adyen': 'Adyen',            
            'InvoicePayment': 'InvoicePayment',
            'Worldline': 'Worldline',            
            'ThirdPartyIntegration': 'ThirdPartyIntegration',
            'MobilePay': 'MobilePay',
            'Mollie': 'Mollie',
            'Reepay': 'Reepay',
            'SepaXml': 'SepaXml',
        });

        var successfulCallback = function (response) {
            var addMissingCurrencies = function (arrayOfFees, type, currencies) {
                var filteredArray = arrayOfFees.filter(function (fee) {
                    return currencies.filter(function (currency) { return currency === fee.Currency; }).length > 0;
                });

                var missingCurrenciesArray = currencies.filter(function (currency) {
                    return arrayOfFees.filter(function (fee) { return currency === fee.Currency; }).length === 0;
                });

                for (var i = 0; i < missingCurrenciesArray.length; i++) {
                    filteredArray.push({
                        Type: type,
                        Amount: 0,
                        Currency: missingCurrenciesArray[i]
                    });
                }

                return filteredArray;
            };

            var paymentProviderHandlingFees = response.data;

            vm.creditCardFees = {
                handlingFeesMode: vm.disableAutomaticallyFeeBlock() ? vm.HANDLING_FEES_MODE.Custom : paymentProviderHandlingFees.CreditCardHandlingFeesMode,
                handlingFees: paymentProviderHandlingFees.CustomHandlingFees.filter(function (fee) {
                    return fee.Type === CUSTOM_HANDLING_FEE_TYPE.CreditCard;
                })
            };
            vm.creditCardFees.handlingFees = addMissingCurrencies(vm.creditCardFees.handlingFees, CUSTOM_HANDLING_FEE_TYPE.CreditCard, paymentProviderHandlingFees.Currencies);

            vm.directDebitFees = {
                handlingFeesMode: vm.disableAutomaticallyFeeBlock() ? vm.HANDLING_FEES_MODE.Custom : paymentProviderHandlingFees.DirectDebitHandlingFeesMode,
                handlingFees: paymentProviderHandlingFees.CustomHandlingFees.filter(function (fee) {
                    return fee.Type === CUSTOM_HANDLING_FEE_TYPE.DirectDebit;
                })
            };
            vm.directDebitFees.handlingFees = addMissingCurrencies(vm.directDebitFees.handlingFees, CUSTOM_HANDLING_FEE_TYPE.DirectDebit, paymentProviderHandlingFees.Currencies);

            vm.payPalFees = {
                handlingFeesMode: vm.disableAutomaticallyFeeBlock() ? vm.HANDLING_FEES_MODE.Custom : paymentProviderHandlingFees.PayPalHandlingFeesMode,
                handlingFees: paymentProviderHandlingFees.CustomHandlingFees.filter(function (fee) {
                    return fee.Type === CUSTOM_HANDLING_FEE_TYPE.PayPal;
                })
            };
            vm.payPalFees.handlingFees = addMissingCurrencies(vm.payPalFees.handlingFees, CUSTOM_HANDLING_FEE_TYPE.PayPal, paymentProviderHandlingFees.Currencies);
        };

        vm.$onInit = function () {
            var extId = "";
            if (vm.paymentProviderExternalId) {
                extId = vm.paymentProviderExternalId;
            }
            paymentProviderHandlingFeesSettings
                .getHandlingFees(vm.provider, successfulCallback, extId);
        };

        vm.save = function () {
            const prepared = {
                CreditCardHandlingFeesMode: vm.creditCardFees.handlingFeesMode,
                PayPalHandlingFeesMode: vm.payPalFees.handlingFeesMode,
                DirectDebitHandlingFeesMode: vm.directDebitFees.handlingFeesMode,
                CustomHandlingFees: []
            };

            const filterAndPopulate = function (arrayOf, arrayTo) {
                var filteredArray = arrayOf.filter(function (fee) {
                    return fee.Amount && fee.Amount !== 0;
                });

                for (var i = 0; i < filteredArray.length; i++) {
                    arrayTo.push(filteredArray[i]);
                }

                return filteredArray;
            };

            filterAndPopulate(vm.payPalFees.handlingFees, prepared.CustomHandlingFees);
            filterAndPopulate(vm.directDebitFees.handlingFees, prepared.CustomHandlingFees);
            filterAndPopulate(vm.creditCardFees.handlingFees, prepared.CustomHandlingFees);

            var extId = "";
            if (vm.paymentProviderExternalId) {
                extId = vm.paymentProviderExternalId;
            }

            paymentProviderHandlingFeesSettings.saveHandlingFees(vm.provider, prepared, function () {
                $location.path(vm.redirectUrl);
            }, extId);
        };

        vm.showCreditCardBlock = function () {
            const allowedPSP =
                [PSP_TYPE.FakeProvider,
                PSP_TYPE.PayOne,                
                PSP_TYPE.Stripe, 
                PSP_TYPE.StripeV2,
                PSP_TYPE.Unzer, 
                PSP_TYPE.UnzerV2,
                PSP_TYPE.Adyen,                                
                PSP_TYPE.Stripe,
                PSP_TYPE.Worldline,                
                PSP_TYPE.ThirdPartyIntegration,
                PSP_TYPE.Mollie];
            return allowedPSP.includes(vm.provider);
        };

        vm.disableCustomFeeBlock = function (selectedValue) {
            return selectedValue !== vm.HANDLING_FEES_MODE.Custom;
        };

        vm.disableAutomaticallyFeeBlock = function () {
            const allowedPSP =
                [PSP_TYPE.PayOne,
                PSP_TYPE.Adyen,                
                PSP_TYPE.Mollie,
                PSP_TYPE.SepaXml];
            return !allowedPSP.includes(vm.provider);
        };

        vm.showDirectDebitBlock = function () {
            const allowedPSP =
                [PSP_TYPE.FakeProvider,
                PSP_TYPE.PayOne,                
                PSP_TYPE.Stripe,
                PSP_TYPE.StripeV2,
                PSP_TYPE.Unzer,
                PSP_TYPE.UnzerV2,
                PSP_TYPE.Adyen,                                
                PSP_TYPE.GoCardless,
                PSP_TYPE.Stripe,                
                PSP_TYPE.ThirdPartyIntegration,
                PSP_TYPE.Mollie,
                PSP_TYPE.Reepay,
                PSP_TYPE.SepaXml];
            return allowedPSP.includes(vm.provider);
        };

        vm.showPayPalBlock = function () {
            const allowedPSP = [PSP_TYPE.PayPal];
            return allowedPSP.includes(vm.provider);
        };

        vm.showInfoBox = function () {
            const allowedPSP =
                [PSP_TYPE.PayPal,
                PSP_TYPE.FakeProvider,
                PSP_TYPE.PayOne,                
                PSP_TYPE.Stripe,
                PSP_TYPE.StripeV2,    
                PSP_TYPE.Adyen,                                
                PSP_TYPE.GoCardless,
                PSP_TYPE.Stripe,                
                PSP_TYPE.ThirdPartyIntegration,
                PSP_TYPE.Mollie, 
                PSP_TYPE.Reepay,
                PSP_TYPE.SepaXml];
            return allowedPSP.includes(vm.provider);
        };
    }
})();
